import axios from 'axios';
import { getXSRFToken } from '../util/server-util';

function createApiHandler() {
  const header_values = {
    'Content-Type': 'application/json',
    'X-XSRFToken': getXSRFToken()
  };

  const instance = axios.create({
    baseURL: '/api/',
    headers: {
      common: {},
      get: header_values,
      post: header_values,
      patch: header_values,
      put: header_values,
      delete: header_values,
    }
  });

  instance.interceptors.response.use((response) => {
    return response.data;
  }, (error) => {
    if (error.response) {
      return Promise.reject(error.response);
    }
    return Promise.reject(error);
  });
  return instance;
}

// Return an axios instance configured for interacting with the Lucid Auth API
export const API = () => { return createApiHandler(); };
